<header class="score-board__header">
  <h1 class="score-board__title">
    {{ 'LECTURES.PROGRESS.SCORE_BOARD' | translate }}
  </h1>
  <div class="badge score-board__badge">
    {{ 'LECTURES.PROGRESS.EARNED' | translate }}
    {{ ((userScore$ | async) === 1 ? 'LECTURES.PROGRESS.SINGLE_POINT' : 'LECTURES.PROGRESS.POINTS') | translate: { points: (userScore$ | async) } }}
  </div>
  <button type="button" class="btn score-board__x-btn" (click)="closeModal()"></button>
</header>

<main class="score-board__main">
  <div id="my-progress">
    <table class="score-board__table">
      <tr class="score-board__table-row" *ngFor="let level of levelsData; index as i; trackBy: levelsTrackBy">
        <td class="score-board__you-are-here">
          {{ level.current ? ('LECTURES.PROGRESS.YOU_ARE_HERE' | translate) : '' }}
        </td>
        <td [ngClass]="['score-board__status-icon', level.done ? 'completed' : 'not-completed']">
          <img *ngIf="level.done" class="score-board__checked-icon" src="assets/images/checked.svg" alt="level completed">
        </td>
        <td>
          {{ 'LECTURES.PROGRESS.LEVEL' | translate }}
          {{ i + 1 }}
        </td>
        <td class="score-board__planet">
          <img class="score-board__planet-icon" [src]="'assets/images/progress/' + level.stage.toLowerCase() + '.svg'" alt="">
          {{ 'PLANETS.' + level.stage | translate }}
        </td>
        <td>
          {{ (level.numLect === 1 ? 'LECTURES.PROGRESS.SINGLE_POINT' : 'LECTURES.PROGRESS.POINTS') | translate: { points: level.numLect } }}
        </td>
      </tr>
    </table>
  </div>
</main>

<footer class="score-board__footer">
  <button type="button" class="btn btn-primary score-board__close-btn" (click)="closeModal()">{{ 'LECTURES.PROGRESS.CLOSE' | translate }}</button>
</footer>
